import PageHeader from './page-header';

function getAccountData(accountData) {
    return {
        isEnvironmentAcceptance: accountData['environment'] === 'ACCEPTANCE',
        showSecrecyNote: accountData['client_data_secrecy_note'],
        showCompanyName: accountData['client_header_show_company_name'],
        accountName: accountData['accountName'],
        userName: accountData['username'],
    };
}

const pageHeaderInit = (accountData) => {
    if (accountData && Object.hasOwn(PageHeader, 'accountProps')) {
        PageHeader.accountProps = getAccountData(accountData);
    }
    customElements.define('page-header', PageHeader);
};

export default pageHeaderInit;
